import type { ValueOf } from '../util/typeUtils';

export const LOAN_REQUEST_RESOLVERS = {
    find: 'find',
    /** intern resolver — saga-only (system context); not granted to human roles */
    findIdsByPhone: 'findIdsByPhone',
    get: 'get',
    getAcceptedOfferById: 'getAcceptedOfferById',
    getAcceptedOfferCommission: 'getAcceptedOfferCommission',
    getAcceptedOfferCounts: 'getAcceptedOfferCounts',
    getAcceptedOffers: 'getAcceptedOffers',
    getAcknowledgedDocuments: 'getAcknowledgedDocuments',
    getActiveUserSetLeads: 'getActiveUserSetLeads',
    getAddedAssignedUserLeads: 'getAddedAssignedUserLeads',
    getAgreements: 'getAgreements',
    getApplicant: 'getApplicant',
    getApplicantNotes: 'getApplicantNotes',
    getAssignedAdvisorForLead: 'getAssignedAdvisorForLead',
    getBankOffersByLeadId: 'getBankOffersByLeadId',
    getBanks: 'getBanks',
    getBucket: 'getBucket',
    getBucketCounts: 'getBucketCounts',
    getBucketHistory: 'getBucketHistory',
    getCensoredApplicant: 'getCensoredApplicant',
    getCensoredLoanRequest: 'getCensoredLoanRequest',
    getConsorsConsolidationAccess: 'getConsorsConsolidationAccess',
    getConsorsConsolidationData: 'getConsorsConsolidationData',
    getConsorsNotesByLeadId: 'getConsorsNotesByLeadId',
    getConsorsNotesRequestStatus: 'getConsorsNotesRequestStatus',
    getConsorsNoteStatus: 'getConsorsNoteStatus',
    getConsorsOfferStatus: 'getConsorsOfferStatus',
    getConsorsSubscriptionStatus: 'getConsorsSubscriptionStatus',
    getCountByBuckets: 'getCountByBuckets',
    getCountByUserIds: 'getCountByUserIds',
    getCounts: 'getCounts',
    getCreditRatingRequestedStatus: 'getCreditRatingRequestedStatus',
    getDemandedDocuments: 'getDemandedDocuments',
    getDistributedCount: 'getDistributedCount',
    getDuplicateInfoByLead: 'getDuplicateInfoByLead',
    getDuplicates: 'getDuplicates',
    getEuropacePortalLink: 'getEuropacePortalLink',
    getEuropaceProcessData: 'getEuropaceProcessData',
    getEuropaceProcessEvents: 'getEuropaceProcessEvents',
    getEuropaceProcessEventsRequestStatus: 'getEuropaceProcessEventsRequestStatus',
    getEuropaceProcessId: 'getEuropaceProcessId',
    getIdsWithAttribution: 'getIdsWithAttribution',
    getLeadsWithFailedAttribution: 'getLeadsWithFailedAttribution',
    getLeadsWithoutAttribution: 'getLeadsWithoutAttribution',
    getLoanRequestMailStatusData: 'getLoanRequestMailStatusData',
    getLoanRequestStatusData: 'getLoanRequestStatusData',
    getLoanRequestSummaryById: 'getLoanRequestSummaryById',
    getLoanRequestsWithUnverifiedDocuments: 'getLoanRequestsWithUnverifiedDocuments',
    getNotes: 'getNotes',
    getOffer: 'getOffer',
    getOfferAcceptanceStatusByOfferId: 'getOfferAcceptanceStatusByOfferId',
    getOfferById: 'getOfferById',
    getOfferDocumentsUploadData: 'getOfferDocumentsUploadData',
    getOfferRequestConditionsLatest: 'getOfferRequestConditionsLatest',
    getOfferRequestState: 'getOfferRequestState',
    getOffersAcceptanceStatusByLoanRequestId: 'getOffersAcceptanceStatusByLoanRequestId',
    getOffersByRequestId: 'getOffersByRequestId',
    getOffersBySource: 'getOffersBySource',
    getOffersSynchronizationStatus: 'getOffersSynchronizationStatus',
    getPc24CreditImportStatus: 'getPc24CreditImportStatus',
    getPhoneLegitimation: 'getPhoneLegitimation',
    getProcessedNotifications: 'getProcessedNotifications',
    getRecordedDocuments: 'getRecordedDocuments',
    getResubmissionCount: 'getResubmissionCount',
    getResubmissionLoanRequestsByDate: 'getResubmissionLoanRequestsByDate',
    getSchufa: 'getSchufa',
    getSkagCreditApplication: 'getSkagCreditApplication',
    getSummary: 'getSummary',
    getSystemNotes: 'getSystemNotes',
    getUnacknowledgedChanges: 'getUnacknowledgedChanges',
    getUnreadConsorsNotes: 'getUnreadConsorsNotes',
    getUserIds: 'getUserIds',
    isApplicantAdvertisementConsentAgreed: 'isApplicantAdvertisementConsentAgreed',
    isApplicantDataProtectionAgreed: 'isApplicantDataProtectionAgreed',
    isApplicantEmailVerified: 'isApplicantEmailVerified',
    isAssignedToUser: 'isAssignedToUser',
    isOfCorporation: 'isOfCorporation',
    isUnassignedOfCorporation: 'isUnassignedOfCorporation',
} as const;

export type LOAN_REQUEST_RESOLVER = ValueOf<typeof LOAN_REQUEST_RESOLVERS>;
